<template>
  <div class="mt-2">
    <v-btn-toggle
      ref="type"
      v-model="type"
      mandatory
    >
      <v-btn value="FEL" v-if="this.id && this.app === 1 || this.app === 2">
        Usuarios Imprenta
      </v-btn>
      <v-btn value="RECEPCION" v-if="this.reception_id && this.reception_id > 0">
        Usuarios Recepción
      </v-btn>
    </v-btn-toggle>
    <v-row>
      <v-col cols="12">
        <vuetify-table
          :type="type"
          :headers="headers"
          :api-u-r-l="apiURL"
          :title="currentTitle"
          :query-params="queryParams"
          permisosNuevoRegistro="crear_usuario_empresa"
        >
          <template v-slot:actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  :color="themeColor"
                  dark
                  @click="editItem(item)"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="type !== 'FEL'">
              <template v-slot:activator="{ on }">
                <v-icon
                  :color="themeColor"
                  dark
                  @click="openModalDelete(item)"
                  v-on="on"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
            <v-tooltip v-if="!restoringPassword" bottom >
              <template v-slot:activator="{ on }">
                <v-icon
                  :color="themeColor"
                  dark
                  @click="openModalPass(item)"
                  v-on="on"
                >
                  mdi-lock
                </v-icon>
              </template>
              <span>Restablecer contraseña</span>
            </v-tooltip>
            <v-progress-circular
              v-else
              indeterminate
              :color="themeColor"
            ></v-progress-circular>
          </template>
        </vuetify-table>
        <v-dialog
          v-model="dialog"
          max-width="620"
        >
          <v-card>
            <v-card-title class="headline">
              ¿Estás seguro de que quieres eliminar este registro?
            </v-card-title>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="red darken-1"
                text
                @click="dialog = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                :loading="toggleStatus"
                @click.prevent="deleteItem()"
              >
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogPass"
          max-width="650"
        >
          <v-card>
            <v-card-title class="headline">
              ¿Estás seguro de que quieres restablecer la contraseña de este registro?
            </v-card-title>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="green darken-1"
                text
                @click="dialogPass = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                :loading="toggleStatusPass"
                @click.prevent="resetPass()"
              >
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  components: {
    VuetifyTable,
  },
  props: {
    enterpriseId: { default: null },
    queryParams: {
      type: String,
    },
  },
  data: () => ({
    dialog: false,
    toggleStatus: false,
    dialogPass: false,
    toggleStatusPass: false,
    restoringPassword: false,
    id: false,
    reception_id: false,
    app: '',
    headers: [
      {
        text: 'Nombre',
        value: 'name',
        align: 'left',
        sortable: true,
      }, {
        text: 'Email',
        value: 'email',
        align: 'left',
        sortable: true,
      }, {
        text: 'Rol',
        value: 'description',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Estado',
        value: 'active',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Acciones',
        value: 'action',
        sortable: false,
      },
    ],
    titles: {
      FEL: 'Usuarios Imprenta',
      RECEPTION: 'Usuarios Recepción',
    },
    items: [],
    totalItems: 0,
    apiURLBase: '/api/enterprises',
    apiURLUser: 'users/type',
    type: 'FEL',
    name: '',
  }),
  computed: {
    apiURL() {
      return `${this.apiURLBase}/${this.enterpriseId}/${this.apiURLUser}/${this.type}`;
    },
    currentTitle() {
      return this.titles[this.type];
    },
    enterprise() {
      return this.$store.state.profile.enterprise;
    },
    ...mapGetters({
      themeColor: 'theme/themeColor',
    }),
  },
  mounted() {
    this.id = this.enterprise.id;
    this.reception_id = this.enterprise.receptor_id;
    this.app = this.enterprise.type;

    if (!this.can('cambiar_estado_usuario_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
    }
  },
  methods: {
    editItem(item) {
      const editedItem = { ...item };
      this.$router.push({
        path: `${this.$router.currentRoute.path}/${editedItem.id}/${this.type}/editar`,
      });
    },
    openModalDelete(item) {
      this.dialog = true;
      this.item = item;
    },
    deleteItem() {
      const url = `${this.apiURL}/${this.item.id}`;
      window.axios.delete(url)
      .then((response) => {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
        this.dialog = false;
      });
    },
    openModalPass(item) {
      this.dialogPass = true;
      this.item = item;
    },
    resetPass() {
      this.restoringPassword = true;
      window.axios.put(`${this.apiURLBase}/${this.enterpriseId}/${this.apiURLUser}/${this.type}/${this.item.id}/reset_password`, {
          id: this.item.id,
      }).then(() => {
        this.restoringPassword = false;
      });
      this.dialogPass = false;
    },
  },
};
</script>
